import React from 'react'
import OdxIcon from './Odx-Icon'
import {odxIconSets} from '../constants'

export interface OdxWizardStep {
    label: string,
    children: React.ReactNode,
    isActive?: boolean,
    isPassed?: boolean,
}


interface OdxWizardProps {
    variant: "horizontal" // | "vertical",
    // responsive: boolean,
    steps: OdxWizardStep[],
    className?: string
}

//todo: format this
const OdxWizard: React.FC<OdxWizardProps> = ({steps, className}) => {
    return (
        <div style={{maxHeight: '600px'}} className={`odx-wizard ${className ? className : ''}`}>

            <div
                className={"odx-wizard-step--visible odx-wizard-step odx-wizard-step--touched " +
                    `${steps[0].isPassed ? 'odx-wizard-step--passed ' : ' '}}  ${steps[0].isActive ? 'odx-wizard-step--active ' : ' '} odx-wizard-step--is-last-touched odx-wizard-step--valid`}
                tabIndex={0}><span className="odx-wizard-step__label">{steps[0].label}</span>
                <div className="odx-wizard-step__holder"><span className="odx-wizard-step__line-before"></span><span
                    className="odx-wizard-step__circle">
          {steps[0].isPassed && (<OdxIcon name="check" iconSet={odxIconSets.core} size={"md"}
                                          className="odx-wizard-step__icon"><span></span></OdxIcon>)}
            </span><span className="odx-wizard-step__line-after"></span></div>
            </div>

            <div className="odx-wizard-step__dotted-line"></div>
            {steps.slice(1, steps.length - 1).map((step, index) => (
                <div
                    className={"odx-wizard-step--visible odx-wizard-step odx-wizard-step--touched " +
                        `${step.isPassed ? 'odx-wizard-step--passed ' : ' '}}  ${step.isActive ? 'odx-wizard-step--active ' : ' '} odx-wizard-step--is-last-touched odx-wizard-step--valid`}
                    tabIndex={index}><span className="odx-wizard-step__label">{step.label}</span>
                    <div className="odx-wizard-step__holder"><span className="odx-wizard-step__line-before"></span><span
                        className="odx-wizard-step__circle">
          {step.isPassed && (<OdxIcon name="check" iconSet={odxIconSets.core} size={"md"}
                                      className="odx-wizard-step__icon"><span></span></OdxIcon>)}
            </span><span className="odx-wizard-step__line-after"></span></div>
                </div>
            ))}
            <div className="odx-wizard-step__dotted-line"></div>
            <div
                className={"odx-wizard-step--visible odx-wizard-step odx-wizard-step--touched " +
                    `${steps[steps.length - 1].isPassed ? 'odx-wizard-step--passed ' : ' '}}  ${steps[steps.length - 1].isActive ? 'odx-wizard-step--active ' : ' '} odx-wizard-step--is-last-touched odx-wizard-step--valid`}
                tabIndex={steps.length - 1}><span
                className="odx-wizard-step__label">{steps[steps.length - 1].label}</span>
                <div className="odx-wizard-step__holder"><span className="odx-wizard-step__line-before"></span><span
                    className="odx-wizard-step__circle">
          {steps[steps.length - 1].isPassed && (<OdxIcon name="check" iconSet={odxIconSets.core} size={"md"}
                                                         className="odx-wizard-step__icon"><span></span></OdxIcon>)}
            </span><span className="odx-wizard-step__line-after"></span></div>
            </div>
        </div>
    );
}

export default OdxWizard;